import { render, staticRenderFns } from "./PaymentMethodIcon.vue?vue&type=template&id=7cd71b2c&scoped=true"
import script from "./PaymentMethodIcon.vue?vue&type=script&lang=js"
export * from "./PaymentMethodIcon.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodIcon.vue?vue&type=style&index=0&id=7cd71b2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd71b2c",
  null
  
)

export default component.exports